/**
 * Create BudgetController
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

angular.module('flsControllers').controller('BudgetController', [
    '$scope',
    '$window',
    'Budget',
    'Profile',
    function($scope, $window, Budget, Profile){

    // Set the profile
    $scope.profile = {};

    // Set the Loading state
    $scope.budgets = [];

    // Set the Source
    $scope.source = {
        balance:null
    };

    // Set the Destination
    $scope.destination = {
        balance:null
    };

    // Set the Amount
    $scope.amount = 0;

    /**
     * Calculate the Result
     *
     * @return number
     */
    $scope.result = function(){

        var $sourceJar = $scope.source_jar;
        var $destinationJar = $scope.destination_jar;

        if ($sourceJar && $destinationJar){
            return $destinationJar.balance + $scope.amount;
        }

        return null;
    };

    /**
     * Tranferable Budgets
     *
     * @return boolean
     */
    $scope.transferableBudgets = function(profile){
        return _.filter(profile.budgets, function(budget){
            return $scope.isMine(budget) || $scope.isMyDescendant(budget)
        })
    }

    /**
     * True if the Budget owner matches the profile
     *
     * @param  {Object}  budget
     * @return {Boolean}
     */
    $scope.isMine = function(budget){
        return _.get(budget, 'budget_jar_owner.owner_id') == $scope.profile.id;
    }

    /**
     * True if the Budget is a descendant of a a budget that is primary
     *
     * @param  {Object}  budget
     * @return {Boolean}
     */
    $scope.isMyDescendant = function(budget){
        /* Locate root budget */
        var rootBudget = $scope.rootBudget(budget)
        /* Evaluate the  */
        return $scope.isMine(rootBudget)
    }

    /**
     * Locate the Budget with lowest left and highest right
     * @param  {Object} budget
     * @return {Object}
     */
    $scope.rootBudget = function(leaf){
        return _.chain($scope.profile.budgets)
                .filter(function(budget){
                    return budget.tree_left < leaf.tree_left && budget.tree_right > leaf.tree_right
                })
                .sortBy('tree_right')
                .last()
                .value()
    }


    /**
     * True if the user can transfer moneys
     *
     * @return boolean
     */
    $scope.canTransfer = function(){
        var $sourceJar = $scope.source;

        // We need to verify
        // 1. amount is greater than 0
        if ($scope.amount <= 0) return false;
        // 2. Source balance is greater than amount and Destiantion is set
        if ($sourceJar && $scope.destination_jar){
            return $sourceJar.balance >= $scope.amount
        }
        return false;
    }

    /**
     * Opposite of the Can Transfer
     *
     * @return boolean
     */
    $scope.cannotTransfer = function(){
        return !$scope.canTransfer();
    }

    /**
     * Load Profile's Budget Jars
     *
     * @param  int $id
     * @return Void
     */
    $scope.init = function($id){
        Profile.get({id:$id})
               .$promise
               .then(function(profile){
                    /* Set Profile*/
                    $scope.profile = profile;
                    /* Set transferable Budgets */
                    $scope.budgets = $scope.transferableBudgets(profile)
                })
    }

    /**
     * Init the Source Budget Jar
     *
     * @return void
     */
    $scope.setSource = function(){

        var $jar = $scope.source_jar;

        if ($jar){
            $scope.source = Budget.get({id:$jar.id});
        }
    }

    /**
     * Init the Desctination Budget Jar
     *
     * @return void
     */
    $scope.setDestination = function(){
        var $jar = $scope.destination_jar;

        if ($jar){
            $scope.destination = Budget.get({id:$jar.id});
        }
    }

    /**
     * Filter the destination Jar
     *
     * @return boolean
     */
    $scope.filterDestination = function(){
        var $sourceJar = $scope.source_jar;

        if($sourceJar){
            return function(item){
                // It is not the same as the source
                return item.id != $sourceJar.id;
            }
        }

        return false;
    }

    /**
     * Filter the destination Jar to same period
     *
     * @return boolean
     */
    $scope.filterSamePeriod = function(){
        var $sourceJar = $scope.source_jar;

        if($sourceJar){
            return function(item){
                return (new Date(item.valid_from) <= new Date($sourceJar.valid_to)) &&
                       (new Date(item.valid_to) >= new Date($sourceJar.valid_from));
            }
        }

        return false;
    }

    /**
     * Filter the destination Jar to same period
     *
     * @return boolean
     */
    $scope.filterSameBrand = function(){
        var $sourceJar = $scope.source_jar;

        if($sourceJar){
            return function(item){
                // define comparison Result
                var result = [];

                // Intersect the brands
                // We are only interested in Each Jar in Destination that has the same Brands as the Jar in the Source
                angular.forEach(item.budget_type.brands, function(value,index){
                    angular.forEach($sourceJar.budget_type.brands, function(object,index1){
                        if(value.id==object.id){
                            result.push(object)
                        }
                    })
                })

                // return length
                // if the results intersect, the length is > 0, esle it is == 0, which evaluates to 0
                return result.length;
            }
        }

        return false;
    }
}]);


